export default {
  users: orgId => ['org', String(orgId), 'users'],
  user: (orgId, id) => ['org', String(orgId), 'users', String(id)],
  userQuery: () => ['query'],
}
